<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [canShowClearFilter]="true"
    (onClearFilterEvent)="clearSearchFilter()"
    >
  </app-header-form>
</div>

<div class="container-fluid search-container">
  <div class="card">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date d'activit&eacute;</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromFilterDate"
              [valueFrom]="fromFilterDate"
              typeTo="ToFilterDate"
              [valueTo]="toFilterDate"></custom-date-range-input>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid navBarInvoice">
  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start">
    <div fxFlex="100" fxFlex.gt-sm="100" fxLayoutAlign="start">
      <button mat-stroked-button class="btnNavBarColor" (click)="$event.stopPropagation();onExport();" tooltip="Exporter au format excel">
        <mat-icon>download</mat-icon>
        <span>Exporter sur Excel</span>
      </button>
      <div *ngIf="!AreDatesValid" class="error">Les dates doivent être dans l'ordre chronologique si les deux sont définies.</div>
    </div>
  </div>
</div>
